import React from 'react';
import { Button, Fab, Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { ArrowUp } from '@one-thd/sui-icons';
import { ScrollToAnchorRef, scrollToAnchorPosition, } from '../../shared/anchor-scroll';
import { rhGeneral, rhFAQ, rhAnalytics } from '../../../constants/RewardsHub';
import { ComponentHeading } from '../../shared/rewards-hub';
import { analyticsClick } from '../../../utils/analytics';
import DataFAQ from './DataFAQ.json';
import DataCompanyFAQ from './DataCompanyFAQ.json';
import { RewardsAndOffersContext } from '../../../contexts';
var Item = function (_a) {
    var item = _a.item;
    return (React.createElement("div", { className: "sui-mb-12" },
        React.createElement("div", { className: "sui-mb-6 sui-flex sui-gap-2" },
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Q:"),
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, item.question)),
        React.createElement("div", { className: "sui-flex sui-gap-2" },
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "A:"),
            React.createElement(Typography, { variant: "body-base" }, item.answer))));
};
var Collective = function (_a) {
    var list = _a.list;
    var collective = list.map(function (item, idx) { return (React.createElement(Item, { item: item, key: "faq".concat(idx) })); });
    return React.createElement("div", { className: "" }, collective);
};
var RenderFaqCta = function () {
    var fabClick = function () { return scrollToAnchorPosition({ top: 0 }); };
    // Add the analytics click functionality to the button and the Fab onClick
    return (React.createElement("div", { className: "sui-mt-6 sui-flex sui-w-full sui-justify-between" },
        React.createElement(Button, { variant: "text", disabled: false, fullWidth: false, href: rhGeneral.faqTermsAndConditions, onClick: function () {
                analyticsClick(rhAnalytics.termsAndConditions);
            }, style: {
                textDecoration: 'none',
            } }, "Pro Xtra Terms & Conditions"),
        React.createElement(Fab, { "aria-label": "top", label: "Top", onClick: function () {
                analyticsClick(rhAnalytics.returnToTop);
                fabClick();
            } },
            React.createElement(ArrowUp, { size: "small" }))));
};
var ListContainer = function (_a) {
    var children = _a.children, classes = _a.classes;
    return (React.createElement("div", { className: "".concat(classes) },
        React.createElement(ComponentHeading, { titleArray: rhFAQ.headingTitle }),
        React.createElement("div", { className: "sui-flex sui-w-full sui-flex-wrap" }, children),
        React.createElement(RenderFaqCta, null)));
};
var RenderProXtraFaq = function () {
    var isHDPassVerbageEnabled = ['1', 1].includes(useConfigService('ENABLE_HD_PASS_VERBAGE'));
    var isChildAccount = React.useContext(RewardsAndOffersContext).isChildAccount;
    var list1 = [];
    var list2 = [];
    if (isChildAccount) {
        list1 = Object.values(DataCompanyFAQ).slice(0, 5);
        list2 = Object.values(DataCompanyFAQ).slice(5, 10);
    }
    else {
        list1 = [
            isHDPassVerbageEnabled ? DataFAQ['1b'] : DataFAQ['1'],
            DataFAQ['2'],
            DataFAQ['3'],
        ];
        list2 = Object.values(DataFAQ).slice(3, 6);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollToAnchorRef, { id: "pro_xtra_FAQ" }),
        React.createElement(ListContainer, { classes: "" },
            React.createElement("div", { className: "sui-grid sui-grid-cols-2 sui-w-full sui-gap-10" },
                React.createElement(Collective, { list: list1 }),
                React.createElement(Collective, { list: list2 })))));
};
var RenderProXtraFaqMobile = function () {
    var isHDPassVerbageEnabled = ['1', 1].includes(useConfigService('ENABLE_HD_PASS_VERBAGE'));
    var isChildAccount = React.useContext(RewardsAndOffersContext).isChildAccount;
    var list = [];
    if (isChildAccount) {
        list = Object.values(DataCompanyFAQ).slice(0, 10);
    }
    else {
        list = [
            isHDPassVerbageEnabled ? DataFAQ['1b'] : DataFAQ['1'],
            DataFAQ['2'],
            DataFAQ['3'],
            DataFAQ['4'],
            DataFAQ['5'],
            DataFAQ['6'],
        ];
    }
    return (React.createElement("div", null,
        React.createElement(ScrollToAnchorRef, { id: "pro_xtra_FAQ" }),
        React.createElement(ListContainer, { classes: "" },
            React.createElement(Collective, { list: list }))));
};
export var ProXtraFAQ = function (props) {
    var isMobile = props.isMobile;
    return isMobile ? React.createElement(RenderProXtraFaqMobile, null) : React.createElement(RenderProXtraFaq, null);
};
